<template>
  <div class="bin-wrapper">

    <!--操作按钮-->
    <div class="op-wrapper custom-wrapper"
      v-if="hasRes('bin_info_create')" >
      <el-button
        type="danger"
        size="medium"
        @click="binFormDialogVisible = true">添加升级包</el-button>
    </div>

    <bin-filter-form
      @filter="updateTableData"
      v-if="hasRes('bin_info_index')" />

    <custom-table
      :fetch="false"
      :data="binInfoList"
      v-if="hasRes('bin_info_index')"
      @data-change="updateTableData">

      <el-table-column
        prop="bin_id"
        label="升级包 ID"
        sortable="custom" >
      </el-table-column>

      <el-table-column
        prop="app_name"
        label="应用名"
        sortable="custom" >
      </el-table-column>

      <el-table-column
        prop="version"
        label="升级包版本号"
        sortable="custom" >
      </el-table-column>

      <el-table-column
        prop="remarks"
        label="备注"
        sortable="custom" >
        <template slot-scope="scope">
          {{ scope.row.remarks || '无' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="create_time"
        label="创建时间"
        sortable="custom" >
        <template slot-scope="scope">
          {{ scope.row.create_time | dateformat }}
        </template>
      </el-table-column>

      <!--<el-table-column-->
        <!--prop="type"-->
        <!--label="应用类型"-->
        <!--sortable="custom" >-->
        <!--<template slot-scope="scope">-->
          <!--<el-tag-->
            <!--:type="scope.row.type === 0 ? 'primary' : 'danger'"-->
            <!--size="mini"-->
            <!--disable-transitions>{{ scope.row.type === 0 ? '普通版' : '定制版' }}</el-tag>-->
        <!--</template>-->
      <!--</el-table-column>-->
    </custom-table>

    <custom-paginate
      :count="binInfoCount"
      v-if="hasRes('bin_info_index')"
      @page-change="updateTableData">
    </custom-paginate>

    <dialog-bin-form
      @data-change="updateTableData"
      v-if="hasRes('bin_info_create')"
      :visible.sync="binFormDialogVisible" />

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'
import BinFilterForm from '@/components/app/BinFilterForm'
import DialogBinForm from '@/components/app/DialogBinForm'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_FILTERS, SET_LOADING } from '@/store/modules/table'

export default {
  name: 'Bin',
  components: {
    CustomTable,
    CustomPaginate,
    BinFilterForm,
    DialogBinForm
  },
  data () {
    return {
      binFormDialogVisible: false
    }
  },
  computed: {
    ...mapState('app', [
      'binInfoList',
      'binInfoCount'
    ]),
    ...mapState('table', [
      'page',
      'pageSize',
      'sort',
      'filters'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_FILTERS,
      SET_LOADING
    ]),
    ...mapActions('app', [
      'getBinInfos'
    ]),

    // 更新表格数据
    async updateTableData () {
      if (!this.hasRes('bin_info_index')) return

      this.setLoading(true)

      try {
        await this.getBinInfos({
          page: this.page,
          pageSize: this.pageSize,
          sort: this.sort,
          filters: this.filters
        })

        this.setLoading(false)
      } catch (err) {
        console.log(err)
        this.setLoading(false)

        this.$message({
          type: 'error',
          message: '获取应用号列表失败'
        })
      }
    }
  },
  mounted () {
    if ('app_id' in this.$route.query) {
      this.setFilters({
        app_id: this.$route.query.app_id
      })
    }

    this.updateTableData()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base";
</style>



// WEBPACK FOOTER //
// src/pages/op/app/Bin.vue